import { compose, withFeatureFlags, } from "@atlassiansox/microscopekit";
import React, { useEffect } from "react";
import TabContainer from "../components/TabContainer";
import setupSentry from "../utils/sentry";
import LoggingPage from "./LoggingPage";
var ObservabilityApp = function (_a) {
    var id = _a.id, flags = _a.flags;
    useEffect(function () {
        // Luigi API does not allow the sentry-trace header via CORS. So we only enable sentry in production
        if (process.env.NODE_ENV === "production") {
            setupSentry();
        }
    }, []);
    if (flags === null || flags === void 0 ? void 0 : flags.observabilityPluginTabs) {
        return React.createElement(TabContainer, { id: id });
    }
    return React.createElement(LoggingPage, { id: id });
};
export default compose(withFeatureFlags(ObservabilityApp));
